import axios from 'axios'
import router from './router'
import {
  Message
} from 'element-ui'
import {
  getCookie
} from './utils/cookie'
import store from './store'
import {
  baseUrl
} from '../config.js'

export const clientSecret = 'ScQEbxyGOdsphRtz2IUcxlWRl0me7TH41PoDO9Zr'

//后端本地
// export const server = 'http://192.168.1.19:8002/admin/'
// export const api = 'http://192.168.1.19:8002/admin/'

// export const server = 'http://192.168.1.20:8002/admin/'
// export const api = 'http://192.168.1.20:8002/admin/'

// export const server = 'http://192.168.1.43:8081/admin/'
// export const api = 'http://192.168.1.43:8081/admin/'

// 正式地址
export const server = 'https://m9adminapi.aacsgo.com/admin/'
export const api = 'https://m9adminapi.aacsgo.com/admin/'




// getData
export const getData = (url, params) => {
  if (getCookie('access_token')) {
    return axios.get(server + url, {
      params
    })
  } else {
    refreshToken(url, params, 'get')
  }
}

export const getApiData = (url, params) => {
  if (getCookie('access_token')) {
    return axios.get(api + url, {
      params
    })
  } else {
    refreshToken(url, params, 'get')
  }
}


// postData
export const postData = (url, params, config) => {
  if (url === 'authorizations') {
    return axios.post(server + url, params, config)
  } else {
    if (getCookie('access_token')) {
      return axios.post(server + url, params, config)
    } else {
      refreshToken(url, params, 'post')
    }
  }
}

export const postApiData = (url, params, config) => {
  if (url === 'authorizations') {
    return axios.post(api + url, params, config)
  } else {
    if (getCookie('access_token')) {
      return axios.post(api + url, params, config)
    } else {
      refreshToken(url, params, 'post')
    }
  }
}

// putData
export const putData = (url, params) => {
  if (url === 'authorizations/current') {
    return axios.put(server + url, params)
  } else {
    if (getCookie('access_token')) {
      return axios.put(server + url, params)
    } else {
      refreshToken(url, params, 'put')
    }
  }
}

export const putApiData = (url, params) => {
  if (url === 'authorizations/current') {
    return axios.put(server + url, params)
  } else {
    if (getCookie('access_token')) {
      return axios.put(api + url, {
        params
      })
    } else {
      refreshToken(url, params, 'put')
    }
  }
}

// patchData
export const patchData = (url, params) => {
  if (url === 'authorizations/current') {
    return axios.patch(server + url, params)
  } else {
    if (getCookie('access_token')) {
      return axios.patch(server + url, params)
    } else {
      refreshToken(url, params, 'patch')
    }
  }
}

export const patchApiData = (url, params) => {
  if (url === 'authorizations/current') {
    return axios.patch(server + url, params)
  } else {
    if (getCookie('access_token')) {
      return axios.patch(api + url, params)
    } else {
      refreshToken(url, params, 'put')
    }
  }
}

// delData
export const delData = (url, params) => {
  if (url === 'authorizations/current') {
    return axios.delete(server + url, {
      params
    })
  } else {
    if (getCookie('access_token')) {
      return axios.delete(server + url, {
        params
      })
    } else {
      refreshToken(url, params, 'delete')
    }
  }
}

export const delApiData = (url, params) => {
  if (url === 'authorizations/current') {
    return axios.delete(api + url, {
      params
    })
  } else {
    if (getCookie('access_token')) {
      return axios.delete(api + url, {
        params
      })
    } else {
      refreshToken(url, params, 'delete')
    }
  }
}

axios.interceptors.request.use(
  config => {
    let token = getCookie('access_token')
    let access_token_validation = getCookie('access_token_validation')
    if (!access_token_validation) {
      //如果验证token不存在，则拼接一个假的token，让其强制退出,作用就是必须在官网登录的用户才能访问其接口
      token = getCookie('access_token') + 'loginerror'
    }

    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error.response)
  }
)

axios.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.response) {
      const err = error.response
      switch (err.status) {
        case 401:
          if (err.data.data === 'deleteLoginStatus') {
            //无权限退出登录
            store.dispatch('deleteLoginStatus')
          }
          Message.error(err.data.error)
          // if (err.data.data === 'Client authentication failed') {
          // 	Message.error('用户名或密码错误')
          // } else {
          // store.dispatch('deleteLoginStatus')
          // Message.error(err.data.error)
          // router.replace({
          // 	path: '/login',
          // 	query: {
          // 		redirect: router.currentRoute.fullPath
          // 	}
          // })
          // }

          break
        default:
          if (err.data.error) {
            Message.error(err.data.error)
          } else if (err.data.errors) {
            const errorMessages = Object.values(err.data.errors)
            errorMessages.forEach(item => {
              item.forEach(subItem => {
                Message.error(subItem)
              })
            })
          } else {
            Message.error(err.data.msg || err.data.message)
          }
          break
      }
      return Promise.reject(err)
    } else {
      Message.error('无法连接到服务器，请检查您的网络')
      return Promise.reject(error)
    }
  }
)

const refreshToken = (url, params, method) => {
  return axios
    .put(server + 'authorizations/current', {
      grant_type: 'refresh_token',
      client_id: 2,
      client_secret: clientSecret,
      refresh_token: getCookie('refresh_token')
    })
    .then(
      res => {
        store.commit('SET_LOGIN_TOKEN', res)
        axios[method](server + url, params)
      },
      () => {
        store.dispatch('deleteLoginStatus')
        Message.error('刷新token失败，请重新登录')
        router.replace({
          path: '/login',
          query: {
            redirect: router.currentRoute.fullPath
          }
        })
      }
    )
}

export default axios
